/*
 * @Author: your name
 * @Date: 2020-11-24 16:17:32
 * @LastEditTime: 2021-01-06 09:15:28
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \dhr_frontend\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'


import user from './user'
import app from './app'
import achievement from './achievement'
import dicts from './dicts'
import laborContract from './laborContract'
import directorPortal from './directorPortal'
import candidateFormal from './candidateFormal'
import purchase from "../views/purchaseManagement/procurementAcceptance/store/purchase"

Vue.use(Vuex)

const store =  new Vuex.Store({
  modules: {
    user,
    app,
    dicts,
    achievement,
    laborContract,
    directorPortal,
    candidateFormal,
    purchase
  }
})

export default store

const initialStateCopy = JSON.parse(JSON.stringify(store.state))

export function resetState () {
  store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)))
}
